<rxap-data-grid [data]="error">
  @if (error.name) {
    <ng-container rxapDataGridRowDef="name"></ng-container>
  }
  <ng-container rxapDataGridRowDef="message"></ng-container>
  @if (hasExtra || hasTags || hasContexts || error.stack) {
    <ng-container rxapDataGridRowDef>
      <th *rxapDataGridHeaderCellDef>
        <span i18n>Details</span>
      </th>
    </ng-container>
  }
  @if (error.stack) {
    <ng-container rxapDataGridRowDef="stack">
      <td *rxapDataGridCellDef="let value">
        <pre>{{ value }}</pre>
      </td>
    </ng-container>
  }
  @if (hasTags) {
    <ng-container rxapDataGridRowDef="tags">
      <td *rxapDataGridCellDef="let value">
        <rxap-data-grid [data]="value" auto></rxap-data-grid>
      </td>
    </ng-container>
  }
  @if (hasExtra) {
    <ng-container rxapDataGridRowDef="extra">
      <td *rxapDataGridCellDef="let value">
        <rxap-data-grid [data]="value" auto></rxap-data-grid>
      </td>
    </ng-container>
  }
  @if (hasContexts) {
    <ng-container rxapDataGridRowDef="contexts">
      <td *rxapDataGridCellDef="let value">
        <rxap-data-grid [data]="value" auto></rxap-data-grid>
      </td>
    </ng-container>
  }
</rxap-data-grid>
